import { call, put, select, takeEvery } from 'redux-saga/effects';
import { nauSearchRequestFailed, nauSearchRequestSuccess } from 'redux/actions/searchItemActions';
import safeFetch from 'shared/api/safeFetch';
import { buildSearchRequest } from 'shared/api/search/searchMapper';
import { SearchItemPostData, SearchRequestType } from 'types/nausearchType';
import { ErrorResponseType } from 'types/reduxTypes';
import { RootState } from 'types/stateTypes';
import { ActionType } from '../actions/themeActions';
import { NAUSEARCH_REQUEST } from '../constants/index';

function* nauSearchRequestHandler(action: ActionType<SearchRequestType>) {
  try {
    const { searchAfterIdSort, searchAfterScore } = yield select((state: RootState) => state.searchItem);
    const { message, filters, pageSize = 10, isAddLoad, typeId } = action.payload;

    const request = buildSearchRequest({
      filters,
      message,
      pageSize,
      ...(isAddLoad && {
        searchAfterIdSort,
        searchAfterScore,
      }),
      typeId,
    });

    const { data: result } = yield call(safeFetch, `/api/search2/search/v3/all/paged`, {
      body: request,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    const hasNext = result?.content?.length >= pageSize;
    const { content, nextPageSearchAfterIdSort, nextPageSearchAfterScore, totalElements, error } = result;

    if (error) throw Error(error);

    yield put(
      nauSearchRequestSuccess({
        data: content as SearchItemPostData[],
        hasNextPage: hasNext,
        isAddLoad,
        searchAfterIdSort: nextPageSearchAfterIdSort,
        searchAfterScore: nextPageSearchAfterScore,
        totalElements,
      })
    );
  } catch (error) {
    console.error('nauSearchRequestError', error);
    const err = error as unknown as ErrorResponseType;
    yield put(nauSearchRequestFailed(err.message as unknown as string));
  }
}

export default function* nauSearchWatcher(): Generator {
  yield takeEvery(NAUSEARCH_REQUEST, nauSearchRequestHandler);
}
